import React from 'react';
import { ChevronLeft, Sparkles } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

export interface RoomAnalysis {
  roomId: string; // inferred
  [key: string]: any;
}

export interface WizardState {
  selections: {
    aiAnalyses?: Record<string, any>;
    categories: Record<string, string[]>;
    budget?: number;
    location?: string;
    materials: string[];
    colors: string[];
    quantities: Record<string, number>;
    areas: string[];
    [key: string]: any;
  };
}

const WizardSearch = () => {
  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-background pt-4 lg:pt-8" dir="rtl">
        <div className="container mx-auto px-4 py-0">
          {/* Breadcrumbs */}
          <div className="mb-6 mt-0">
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink href="/">בית</BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronLeft className="h-4 w-4" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbPage>סוכן חכם</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          <div className="flex items-center justify-center min-h-[60vh]">
            <Card className="w-full max-w-md text-center border-dashed">
              <CardContent className="pt-10 pb-10 space-y-6">
                <div className="bg-primary/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Sparkles className="h-10 w-10 text-primary" />
                </div>

                <div className="space-y-2">
                  <h1 className="text-3xl font-bold tracking-tight">בקרוב</h1>
                  <p className="text-muted-foreground text-lg">
                    הסוכן החכם שלנו נמצא בפיתוח ויעלה לאוויר בקרוב.
                  </p>
                </div>

                <p className="text-sm text-muted-foreground">
                  אנו עובדים על כלי חדשני שיעזור לכם למצוא את המוצרים המושלמים לפרויקט שלכם.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WizardSearch;